import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the trainings step of the breadcrumb: Bookings > Trainings > Training. */
export const Route = createFileRoute("/(private)/booking/trainings")({
  loader: () => ({ crumb: m.coached_training_crumb_list() }),
  component: Outlet,
});
